import { InputObject } from './../../components/ExperimentPlanner/Protocols/utils/InputObject'
import { Dilution } from '../../components/ExperimentPlanner/Protocols/Dilution'


export const ExperimentPlanner2 = () => {
  return (
    <div>
      <Dilution />
    </div>
  )
}
